<figure appMapLegend class="legend-container" id="ftth-legend" aria-label="FTTH legend">
  <figcaption class="legend-title">FTTH</figcaption>
  <div class="legend-items" role="list">
    @for (value of legend.values; track value.label) {
      <div class="legend-item" role="listitem">
        <span class="legend-swatch" [style.background-color]="value.color" aria-hidden="true"></span>
        <span>{{ value.label | translate }}</span>
      </div>
    }
  </div>
</figure>